import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import { AssignedUser } from '@deltek/specification-client/core/Models/listing'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles({
    emptyValue: {
        fontSize: pxToRem(14),
        color: '#bbb',
    },
    cellText: {
        fontSize: pxToRem(14),
        fontFamily: 'Roboto',
    },
})

interface AssignedUsersCellProps {
    value: Partial<AssignedUser>[] | undefined
}

export const formatAssignedUserNames = (
    users: Partial<AssignedUser>[]
): string =>
    users
        .map((u) => {
            const { firstName, lastName } = u.profileInfo ?? {}
            return [firstName, lastName].filter(Boolean).join(' ')
        })
        .filter(Boolean)
        .join(', ')

/** Displays comma-separated names of assigned users; renders an em-dash when none are assigned.
 * Used for columns: assignedContactUsers, assignedBPMUsers, assignedDeltekUsers. */
const AssignedUsersCell = ({ value }: AssignedUsersCellProps) => {
    const classes = useStyles()

    const display = formatAssignedUserNames(value ?? [])

    if (!display) {
        return <Typography className={classes.emptyValue}>{'—'}</Typography>
    }

    return (
        <TooltipEllipsis text={display}>
            <Typography className={classes.cellText} noWrap>
                {display}
            </Typography>
        </TooltipEllipsis>
    )
}

export default AssignedUsersCell
